import React from 'react';

export function RankChange({ change, size = 'sm' }) {
  if (change === null || change === undefined) {
    return <span className="text-coros-text-muted">–</span>;
  }

  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  if (change > 0) {
    return (
      <span className={`flex items-center text-coros-status-success font-medium ${sizeClasses[size]}`}>
        <svg className="w-3 h-3 mr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
        {change}
      </span>
    );
  }

  if (change < 0) {
    return (
      <span className={`flex items-center text-coros-status-error font-medium ${sizeClasses[size]}`}>
        <svg className="w-3 h-3 mr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
        {Math.abs(change)}
      </span>
    );
  }

  return <span className="text-coros-text-muted">–</span>;
}

export default RankChange;
